/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getGroupedNotifications.defs'
export { main as default } from './getGroupedNotifications.defs'
